import { styled } from '@uhg-abyss/web/tools/styled';

export const ContainerStyle = styled.div({
    '.footer': {
        display: 'flex',
        backgroundColor: '#003da1',
        height: '80px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    '.page-footer-section': {
        display: 'flex',
        backgroundColor: '#003da1',
        height: '80px',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontSize: '14px'
    },
    '.page-footer-section #link-info': {
        marginLeft: '32px',
    },
    '.footer a': {
        color: '#fff',
        textDecoration: 'none'
    },
    '.footer a:hover': {
        color: '#fff',
        textDecoration: 'underline',
        textDecorationColor: '#fff'
    },
    '.footer .separator': {
        margin: '0 10px'
    },
});